module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--5-e4310745b5a324c2bcbcb3573e45fab5.jpg";